/*=========================================================================================
  File Name: moduleDocumentUploadGetters.js
  Description: Document Upload Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
